module.exports = __webpack_public_path__ + "fonts/opensans-italic-webfont.c070c92d.ttf";